<template>
  <v-layout
    :class="isCurrentEdition ? 'white' : 'deprecated deprecated_background'"
    align-space-between
    justify-start
    column
    fill-height
  >
    <v-flex
      shrink
      class="sz_background_light"
      py-3
    >
      <v-flex
        md10
        offset-md1
        sm12
        offset-sm0
      >
        <v-layout
          fill-height
          align-center
        >
          <v-flex shrink>
            <AppLogo width="60" />
          </v-flex>
          <v-flex ml-5>
            <h1 class="display-4">
              {{ title }}
            </h1>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
    <v-flex>
      <v-layout
        v-if="getResource && getQuestions"
        justify-center
      >
        <v-flex
          id="sheet-container"
          xs12
          md10
          mt-3
        >
          <a
            class="link_iconed"
            @click.prevent="goBack"
          >
            <v-icon>keyboard_arrow_left</v-icon> {{ $t('sheet.cancel_button') }}</a>
          <v-layout
            column
            :class="[
              'stepper__wrapper pa-3 mb-3 ',
              { 'deprecated deprecated_background': !isCurrentEdition }
            ]"
          >
            <MedicsQuestions :read-only="readOnly" />
          </v-layout>
        </v-flex>
      </v-layout>
      <PageLoader v-else />
    </v-flex>
    <LeaveConfirmDialog ref="confirm" />
  </v-layout>
</template>

<script>
import AppLogo from '@/components/widgets/AppLogo';
import PageLoader from '@/components/widgets/PageLoader';
import MedicsQuestions from '@/pages/SpecialistPackage/Medics/MedicsQuestions';

import LeaveConfirmDialog from '@/components/widgets/LeaveConfirmDialog';
import mainPage from '@/mixins/specialistPackage/mainPage';

export default {
    name: 'SheetMedics',
    components: { LeaveConfirmDialog, MedicsQuestions, PageLoader, AppLogo },
    mixins: [mainPage],
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            vm.$store.dispatch('specialistPackage/loadPage', {
                resourceId: 6,
                familyId: vm.$route.params.familyId,
                type: 'medics'
            });
        });
    },
    computed: {
        title () {
            return this.$t('specialist_package.medics.header');
        },
        permissionsCheck () {
            return this.medicsPackagePermission;
        }
    }
};
</script>

<style scoped></style>
